import LdapSyncService from "../../services/ldapsync.service";

const state = {
    segments: [],
    segment: [],
    systems: [],
    ldapUsers: [],
    isActiveModal: false
};

const mutations = {
    set_segment_list(state, payload) {
        state.segments = payload
    },
    set_segment(state, payload) {
        state.segment = payload;
    },
    set_system_list(state, payload) {
        state.systems = payload;
    },
    set_close_open_modal(state) {
        state.isActiveModal = !state.isActiveModal
        if (!state.isActiveModal) {
            state.segment = [];
        }
       /* state.segment = [];*/

    },
    set_sync_ldapuser(state, payload) {
        state.ldapUsers = payload;
    }
};

const actions = {
    async getSegments({commit}) {
        const segments = await LdapSyncService.getSegmentsService();
        commit("set_segment_list", segments);
        return segments;
    },
    async getSegment({commit}, payload) {
        const segment = await LdapSyncService.getSegmentService(payload)
        commit("set_segment", segment);
        return segment;
    },
    async getSystems({commit}) {
        const systems = await LdapSyncService.getSystemsService();
        commit("set_system_list", systems);
        return systems;
    },
    async AddSegment({dispatch}, payload) {
        const segment = await LdapSyncService.AddSegmentService(payload);
        dispatch("getSegments");
        return segment;
    },
    async deleteSegment({dispatch}, payload) {
        const deletesegment = await LdapSyncService.DeleteSegmentService(payload);
        dispatch("getSegments");
        return deletesegment;
    },
    async syncData({commit}, payload) {
        const syncdata = await LdapSyncService.syncDataService(payload)
        commit("set_sync_ldapuser", syncdata)
        return syncdata;
    },
    async openCloseSyncModal({commit}) {
        await commit("set_close_open_modal");
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
